@if (displayFeatureModal()) {
    <app-feature-information [modalId]="getId()" [showContent]="showContent" (change)="onChange()"></app-feature-information>
} @else {
    <app-default-welcome-content [modalId]="getId()" [showContent]="showContent" (change)="onChange()"></app-default-welcome-content>
}
